export var TypeActionNetwork;
(function (TypeActionNetwork) {
    TypeActionNetwork["Connected"] = "Network > Connected";
    TypeActionNetwork["Disconnected"] = "Network > Disconnected";
})(TypeActionNetwork || (TypeActionNetwork = {}));
export var actionNetworkConnected = function (id) { return ({
    commandId: -1,
    id: id,
    type: TypeActionNetwork.Connected,
}); };
export var actionNetworkDisconnected = function (id) { return ({
    commandId: -1,
    id: id,
    type: TypeActionNetwork.Disconnected,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/actionNetwork.ts
// module id = 284
// module chunks = 3